import axios from "axios";
import { adminMainUrl } from "../../../../Config";


//country state  city ports data
export const getFFSECountry = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SE_COUNTRY_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/country/list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SE_COUNTRY_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSECountry function (redux):", err);
                dispatch({
                    type: "FIND_FF_SE_COUNTRY_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSECountry function:", error);
            dispatch({
                type: "FIND_FF_SE_COUNTRY_FAILURE",
                payload: error,
            });
        }
    };
};
export const getFFSEState = (token, user_id, country_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SE_STATE_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/state/list?country_id=${country_id}`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SE_STATE_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSEState function (redux):", err);
                dispatch({
                    type: "FIND_FF_SE_STATE_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSEState function:", error);
            dispatch({
                type: "FIND_FF_SE_STATE_FAILURE",
                payload: error,
            });
        }
    };
};
export const getFFSECity = (token, user_id, state_id) => {

    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SE_CITY_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        // const body = { quotation_id: quotation_id }

        const apiUrl = `${adminMainUrl}/api/city/list?state_id=${state_id}`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SE_CITY_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSECity function (redux):", err);
                dispatch({
                    type: "FIND_FF_SE_CITY_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSECity function:", error);
            dispatch({
                type: "FIND_FF_SE_CITY_FAILURE",
                payload: error,
            });
        }
    };
};
export const getFFSESeaport = (token, user_id, quotation_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SE_SEAPORT_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        // const body = { quotation_id: quotation_id }

        const apiUrl = `${adminMainUrl}/api/seaport/list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SE_SEAPORT_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSESeaport function (redux):", err);
                dispatch({
                    type: "FIND_FF_SE_SEAPORT_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSESeaport function:", error);
            dispatch({
                type: "FIND_FF_SE_SEAPORT_FAILURE",
                payload: error,
            });
        }
    };
};


//ff -> air -> export -> get query info by quotation
export const getPackageInfoByQuotation = (token, user_id, quotation_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_QUERY_INFO_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const body = { quotation_id: quotation_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/get-query-info-by-quotation-id`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_QUERY_INFO_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getPackageInfoByQuotation function (redux):", err);
                dispatch({
                    type: "FIND_FF_QUERY_INFO_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getPackageInfoByQuotation function:", error);
            dispatch({
                type: "FIND_FF_QUERY_INFO_FAILURE",
                payload: error,
            });
        }
    };
};


//ff -> air -> export -> job order
export const getFFSeaExpJobOrder = (token, user_id, trans_mode = "", trans_type = "") => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_EXP_JOBORDER_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const queryParams = new URLSearchParams();
        if (trans_mode) queryParams.set("trans_mode", trans_mode);
        if (trans_type) queryParams.set("trans_type", trans_type);
        const queryString = queryParams.toString();

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/joborderlist${queryString ? `?${queryString}` : ""}`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_EXP_JOBORDER_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaExpJobOrder function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_EXP_JOBORDER_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaExpJobOrder function:", error);
            dispatch({
                type: "FIND_FF_SEA_EXP_JOBORDER_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> final Quotation 
export const getFFSeaExpFinalQuotation = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_EXP_FINAL_QUOTATION_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/final-quotation-list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_EXP_FINAL_QUOTATION_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaExpFinalQuotation function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_EXP_FINAL_QUOTATION_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaExpFinalQuotation function:", error);
            dispatch({
                type: "FIND_FF_SEA_EXP_FINAL_QUOTATION_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> currency 
export const getFFSeaExpCurrency = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_EXP_CURRENCY_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/currency/list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_EXP_CURRENCY_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaExpCurrency function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_EXP_CURRENCY_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaExpCurrency function:", error);
            dispatch({
                type: "FIND_FF_SEA_EXP_CURRENCY_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> Airport 
export const getFFSeaExpAirport = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_EXP_AIRPORT_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/airport/list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_EXP_AIRPORT_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaExpAirport function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_EXP_AIRPORT_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaExpAirport function:", error);
            dispatch({
                type: "FIND_FF_SEA_EXP_AIRPORT_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> Organisation 
export const getFFSeaExpOrganisation = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_EXP_ORGANISATION_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/organisation-list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_EXP_ORGANISATION_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaExpOrganisation function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_EXP_ORGANISATION_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaExpOrganisation function:", error);
            dispatch({
                type: "FIND_FF_SEA_EXP_ORGANISATION_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> mawb -> unused hawb List 
export const getFFSeaExpUnusedHBLList = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_EXP_UNUSED_HAWB_REQUEST",
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/export/get-unused-hbl-list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_EXP_UNUSED_HAWB_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaExpUnusedHBLList function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_EXP_UNUSED_HAWB_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaExpUnusedHBLList function:", error);
            dispatch({
                type: "FIND_FF_SEA_EXP_UNUSED_HAWB_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> mawb -> unused hawb List  update
export const getFFSeaExpUnusedHAWBUpdateList = (token, user_id, mawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_EXP_UNUSED_HAWB_UPDATE_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/export/get-unused-hbl-list-update?mbl_id=${mawb_id}`;
        // let body = { id: mawb_id }
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_EXP_UNUSED_HAWB_UPDATE_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaExpUnusedHAWBUpdateList function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_EXP_UNUSED_HAWB_UPDATE_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaExpUnusedHAWBUpdateList function:", error);
            dispatch({
                type: "FIND_FF_SEA_EXP_UNUSED_HAWB_UPDATE_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> hawbb details 
export const getFFSeaExportHBLDetail = (token, user_id, hawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_EXP_HAWB_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/export/hbl/view`;
        let body = { id: hawb_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_EXP_HAWB_DETAIL_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaExportHBLDetail function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_EXP_HAWB_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaExportHBLDetail function:", error);
            dispatch({
                type: "FIND_FF_SEA_EXP_HAWB_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> direct MAWB details 
export const getFFSeaExporDirectMAWBDetail = (token, user_id, hawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_EXP_DIRECT_MAWB_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/export/direct-shipment/mbl/view`;
        let body = { id: hawb_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_EXP_DIRECT_MAWB_DETAIL_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaExporDirectMAWBDetail function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_EXP_DIRECT_MAWB_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaExporDirectMAWBDetail function:", error);
            dispatch({
                type: "FIND_FF_SEA_EXP_DIRECT_MAWB_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> mawb details 
export const getFFSeaExportMBLDetail = (token, user_id, mawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_EXP_MAWB_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/export/mbl/view`;
        let body = { id: mawb_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_EXP_MAWB_DETAIL_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaExportMAWBDetail function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_EXP_MAWB_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaExportMAWBDetail function:", error);
            dispatch({
                type: "FIND_FF_SEA_EXP_MAWB_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> shipper organisation -> branch list 
export const getFFSeaExpShipperBranch = (token, user_id, organisation_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_EXP_SHIPPER_BRANCH_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const body = { organisation_id: organisation_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/organisation-branch-list`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_EXP_SHIPPER_BRANCH_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaExpShipperBranch function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_EXP_SHIPPER_BRANCH_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaExpShipperBranch function:", error);
            dispatch({
                type: "FIND_FF_SEA_EXP_SHIPPER_BRANCH_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> shipper organisation -> branch list 
export const getFFSeaExpConsigneeBranch = (token, user_id, organisation_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_EXP_CONSIGNEE_BRANCH_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const body = { organisation_id: organisation_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/organisation-branch-list`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_EXP_CONSIGNEE_BRANCH_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaExpConsigneeBranch function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_EXP_CONSIGNEE_BRANCH_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaExpConsigneeBranch function:", error);
            dispatch({
                type: "FIND_FF_SEA_EXP_CONSIGNEE_BRANCH_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export ->  shipper -> organisation -> branch list -> Bank account list
export const getFFSeaExpShipperBranchBank = (token, user_id, branch_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_EXP_SHIPPER_BRANCH_BANK_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        let body = { branch_id: branch_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/branch-bank-list`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_EXP_SHIPPER_BRANCH_BANK_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaExpShipperBranchBank function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_EXP_SHIPPER_BRANCH_BANK_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaExpShipperBranchBank function:", error);
            dispatch({
                type: "FIND_FF_SEA_EXP_SHIPPER_BRANCH_BANK_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> consignee -> organisation -> branch list -> Bank account list
export const getFFSeaExpConsigneeBranchBank = (token, user_id, branch_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_EXP_CONSIGNEE_BRANCH_BANK_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        let body = { branch_id: branch_id }

        const apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/branch-bank-list`;
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_EXP_CONSIGNEE_BRANCH_BANK_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaExpConsigneeBranchBank function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_EXP_CONSIGNEE_BRANCH_BANK_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaExpConsigneeBranchBank function:", error);
            dispatch({
                type: "FIND_FF_SEA_EXP_CONSIGNEE_BRANCH_BANK_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> console shipment List
export const getFFSeaExportConsoleShipmentList = (token, user_id, page_no, ship_status, queryString = "") => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_EXP_CONSOLE_SHIPMENT_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let baseUrl;
        if (ship_status == "HBL") {
            baseUrl = `${adminMainUrl}/api/freight/forwarding/sea/export/hbl/list`;
        } else if (ship_status == "MBL") {
            baseUrl = `${adminMainUrl}/api/freight/forwarding/sea/export/mbl/list`;
        } else {
            throw new Error("Invalid ship status.")
        }

        const params = new URLSearchParams(queryString);
        if (page_no) {
            params.set("page", page_no);
        }

        const paramString = params.toString();
        const apiUrl = paramString ? `${baseUrl}?${paramString}` : baseUrl;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_EXP_CONSOLE_SHIPMENT_LIST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaExportConsoleShipmentList function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_EXP_CONSOLE_SHIPMENT_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaExportConsoleShipmentList function:", error);
            dispatch({
                type: "FIND_FF_SEA_EXP_CONSOLE_SHIPMENT_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> direct shipment List
export const getFFSeaExportDirectShipmentList = (token, user_id, page_no, queryString = "") => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_EXP_DIRECT_SHIPMENT_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        const baseUrl = `${adminMainUrl}/api/freight/forwarding/sea/export/direct-shipment/mbl/list`;
        const params = new URLSearchParams(queryString);
        if (page_no) {
            params.set("page", page_no);
        }
        const paramString = params.toString();
        const apiUrl = paramString ? `${baseUrl}?${paramString}` : baseUrl;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_EXP_DIRECT_SHIPMENT_LIST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaExportDirectShipmentList function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_EXP_DIRECT_SHIPMENT_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaExportDirectShipmentList function:", error);
            dispatch({
                type: "FIND_FF_SEA_EXP_DIRECT_SHIPMENT_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> console manifest List
export const getFFSeaExportConsoleManifestList = (token, user_id, page_no, queryString = "") => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_EXP_CONSOLE_MANIFEST_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        const baseUrl = `${adminMainUrl}/api/freight/forwarding/sea/export/console-manifest/list`;
        const params = new URLSearchParams(queryString);
        if (page_no) {
            params.set("page", page_no);
        }
        const paramString = params.toString();
        const apiUrl = paramString ? `${baseUrl}?${paramString}` : baseUrl;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_EXP_CONSOLE_MANIFEST_LIST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaExportConsoleManifestList function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_EXP_CONSOLE_MANIFEST_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaExportConsoleManifestList function:", error);
            dispatch({
                type: "FIND_FF_SEA_EXP_CONSOLE_MANIFEST_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

//ff -> air -> export -> unused mawb in console manifest add form
export const getFFSeaExportConsoleManifestMBLAddList = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_SEA_EXP_CONSOLE_MANIFEST_MAWB_ADD_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/sea/export/console-manifest/unused-mbl-add-list`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_FF_SEA_EXP_CONSOLE_MANIFEST_MAWB_ADD_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFSeaExportConsoleManifestMBLAddList function (redux):", err);
                dispatch({
                    type: "FIND_FF_SEA_EXP_CONSOLE_MANIFEST_MAWB_ADD_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFSeaExportConsoleManifestMBLAddList function:", error);
            dispatch({
                type: "FIND_FF_SEA_EXP_CONSOLE_MANIFEST_MAWB_ADD_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

// //ff -> air -> export -> unused mawb in console manifest edit form
// export const getFFSeaExportConsoleManifestMAWBEditList = (token, user_id, console_manifest_id) => {
//     return async function (dispatch) {
//         dispatch({
//             type: "FIND_FF_SEA_EXP_CONSOLE_MANIFEST_MAWB_EDIT_LIST_REQUEST",
//         });

//         let config = {
//             // method: "GET",
//             headers: {
//                 'auth-token': token,
//                 'user_id': user_id,
//                 'Content-Type': 'application/json',
//             }
//         };
//         let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/console-manifest/unused-mawb-add-list`;
//         let body = { id: console_manifest_id }
//         try {
//             axios.post(apiUrl, body, config).then((res) => {
//                 dispatch({
//                     type: "FIND_FF_SEA_EXP_CONSOLE_MANIFEST_MAWB_EDIT_LIST_SUCCESS",
//                     payload: res?.data?.data,
//                 });
//             }).catch((err) => {
//                 console.log("ERROR in getFFSeaExportConsoleManifestMAWBEditList function (redux):", err);
//                 dispatch({
//                     type: "FIND_FF_SEA_EXP_CONSOLE_MANIFEST_MAWB_EDIT_LIST_FAILURE",
//                     payload: err,
//                 });
//             });
//         } catch (error) {
//             console.log("Unexpected error in getFFSeaExportConsoleManifestMAWBEditList function:", error);
//             dispatch({
//                 type: "FIND_FF_SEA_EXP_CONSOLE_MANIFEST_MAWB_EDIT_LIST_FAILURE",
//                 payload: error,
//             });
//         }
//     };
// };


//calcualte toatl freight in mawb
//ff -> air -> export -> unused mawb in console manifest add form
export const calculateTotalFreightMAWB = (token, user_id, hawb_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CALCULATE_TOTAL_FREIGHT_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/freight/forwarding/air/export/mawb/calculate-hawb-no`;
        let body = { hawb_id_arr: hawb_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_CALCULATE_TOTAL_FREIGHT_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in calculateTotalFreightMAWB function (redux):", err);
                dispatch({
                    type: "FIND_CALCULATE_TOTAL_FREIGHT_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in calculateTotalFreightMAWB function:", error);
            dispatch({
                type: "FIND_CALCULATE_TOTAL_FREIGHT_FAILURE",
                payload: error,
            });
        }
    };
};